import { EventConfig } from '../store/interfaces/eventConfig';
import { BrandColors } from './brandColors';

export const eventConfig: EventConfig = {
  name: 'Hackathon 2023',
  description: '<p>Hackathon description</p>',
  textColor: BrandColors.grey20,
  bannerColor: BrandColors.white,
  bannerImageEnabled: false,
  bannerImage: null,
  mediaImage: {
    name: 'BannerMedia.jpg',
    path: 'http://via.placeholder.com/760x450',
    uuid: 'c4cf6f1443ed43d5961a64b4342f07e2',
  },
};
